import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { GatheringSpotType } from '@outdoria/types';
import { fetcher } from '../utils';
import {
  ADMIN_GATHERING_SPOT_TYPES_UPDATE,
  GATHERING_SPOT_TYPE,
  GATHERING_SPOT_TYPES_ALL,
} from '../queryKeys';

export const useAdminUpdateGatheringSpotType = (
  gathering_spot_type_id: string,
) => {
  const queryClient = useQueryClient();

  const mutationFn = async (
    gathering_spot_type: Omit<GatheringSpotType, 'gathering_spot_type_id'>,
  ): Promise<void> => {
    const response = await fetcher(
      `/v2/admin/gathering_spot_types/${gathering_spot_type_id}`,
      {
        method: 'PUT',
        body: JSON.stringify(gathering_spot_type),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      },
    );

    if (response.status !== 204)
      throw new Error(
        (await response.json()).error ??
          'Could not update the gathering spot type for some unforeseen reason!',
      );
    queryClient.invalidateQueries({ queryKey: GATHERING_SPOT_TYPES_ALL });
    queryClient.invalidateQueries({
      queryKey: GATHERING_SPOT_TYPE,
      exact: false,
    });
  };

  const { mutate, error, status, isPending, isSuccess, isError } = useMutation({
    mutationKey: ADMIN_GATHERING_SPOT_TYPES_UPDATE,
    mutationFn,
  });

  return { mutate, error, status, isPending, isSuccess, isError };
};
